// extracted by mini-css-extract-plugin
export default {"alert":"BaseAlert_alert__OuvT7","warning":"BaseAlert_warning__KVjuY","alert__message":"BaseAlert_alert__message__FsOXW"};